import { Workbox } from 'workbox-window';

export function registerSW() {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    const wb = new Workbox('/sw.js');

    wb.addEventListener('installed', event => {
      if (event.isUpdate) {
        console.log('New service worker installed, reloading...');
        window.location.reload();
      } else {
        console.log('Service worker installed for the first time');
      }
    });

    wb.addEventListener('waiting', () => {
      console.log('Service worker is waiting');
    });

    wb.addEventListener('controlling', () => {
      console.log('Service worker is now controlling');
    });

    wb.addEventListener('activated', event => {
      if (!event.isUpdate) {
        console.log('Service worker activated for the first time');
      }
    });

    wb.register().catch(error => {
      console.error('Service worker registration failed:', error);
    });
  }
}
